import { useQuery } from '@tanstack/react-query';
import { QUERY_KEY } from '@/utils';
import { getLayoutAllResources, getLayoutAllResourcesByBusiness } from '@/services';
import { useCurrentPage } from './use-current-page';

export const useLayoutImages = () => {
  const { currentPage } = useCurrentPage();

  const queryFn = currentPage === "business-opportunity" ? getLayoutAllResourcesByBusiness : getLayoutAllResources;

  const {
    data: layoutImages,
    refetch,
    isFetched,
  } = useQuery({
    queryKey: [QUERY_KEY.getLayoutImages, currentPage],
    queryFn,
    staleTime: Infinity,
  });

  return {
    layoutImages,
    getLayoutImages: refetch,
    isFetched,
  };
};
